import { useListBrowserUtils } from '@ts-private/list-browser';
import { logsStore } from './GenericFilterParamLogListBrowser';
import { useEffect } from 'react';

const useGenericLogFilters = () => {
  const { store, update } = useListBrowserUtils(logsStore);

  useEffect(() => {
    update(prev => {
      const hiddenFilters = [];
      if (!prev.filters.logDate) hiddenFilters.push('logTime');
      if (!prev.filters.logEndDate) hiddenFilters.push('logEndTime');
      return { ...prev, hiddenFilters };
    });
  }, [update, store.filters]);
};

export default useGenericLogFilters;
